import React from 'react';

const OPCIONES = [
  { conStock: true, titulo: 'Con stock', detalle: 'Existencias del catálogo de prueba' },
  { conStock: false, titulo: 'Sin stock', detalle: 'Mismos productos con existencia 0' }
];

// Elige si el almacén de prueba entra con las existencias del catálogo o en 0.
const SelectorStockPrueba = ({ id, conStock, onChange, disabled = false }) => (
  <div role="radiogroup" aria-label="Existencias del almacén de prueba" className="grid grid-cols-2 gap-2">
    {OPCIONES.map((op) => {
      const elegida = op.conStock === conStock;
      return (
        <label
          key={op.titulo}
          htmlFor={`${id}-${op.conStock ? 'con' : 'sin'}`}
          className={`rounded-lg border px-3 py-2 cursor-pointer transition-colors focus-within:ring-2 focus-within:ring-blue-400 ${
            elegida ? 'border-blue-500 bg-blue-50 ring-1 ring-blue-500' : 'border-gray-300 bg-white hover:bg-gray-50'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <input
            id={`${id}-${op.conStock ? 'con' : 'sin'}`}
            type="radio"
            name={id}
            checked={elegida}
            onChange={() => onChange(op.conStock)}
            disabled={disabled}
            className="sr-only"
          />
          <span className={`block text-sm font-medium ${elegida ? 'text-blue-700' : 'text-gray-800'}`}>{op.titulo}</span>
          <span className="block text-xs text-gray-500">{op.detalle}</span>
        </label>
      );
    })}
  </div>
);

export default SelectorStockPrueba;
